import React, { useState, useRef } from 'react';
import { interactiveSalesMap } from '../../../../services/interactiveSalesMap';

const useInteractiveSalesMap = () => {
  const [loading, setLoading] = useState(false);
  const [accessDenied, setAccessDenied] = useState(false);
  const [interactiveSalesMapState, setInteractiveSalesMapState] = useState([]);

  const getInteractiveSalesMap = async ({ formattedEnd, formattedStart }) => {
    setLoading(true);
    try {
      const response = await interactiveSalesMap({ formattedEnd, formattedStart });
      if (response?.success && response.data) {
        setInteractiveSalesMapState(response.data);
      } else {
        console.error("Invalid response structure:", response);
      }
    } catch (error) {
      console.error("Error fetching time-based data:", error);
      if (error.status === 403){
        setAccessDenied(true)
      }
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    interactiveSalesMapState,
    getInteractiveSalesMap,
    accessDenied
  };
};

export default useInteractiveSalesMap;
